<div class="job-volume-picker">
  <label class="jvp-label">Source Job</label>
  <nz-select
    style="width: 100%"
    [ngModel]="selectedJob()"
    (ngModelChange)="onJobChange($event)"
    [compareWith]="compareById"
    nzShowSearch
    nzAllowClear
    nzPlaceHolder="Search for a job...">
    @for (job of jobs(); track job.id) {
      <nz-option [nzValue]="job" [nzLabel]="job.name"></nz-option>
    }
    @empty {
      <nz-option nzDisabled nzValue="" nzLabel="No jobs available"></nz-option>
    }
  </nz-select>

  <label class="jvp-label">Velocity Volume (CP)</label>
  <nz-select
    style="width: 100%"
    [ngModel]="selection()"
    (ngModelChange)="onFileChange($event)"
    [compareWith]="compareByPath"
    [nzLoading]="jobFilesResource.isLoading()"
    [nzDisabled]="!selectedJob()"
    nzShowSearch
    nzAllowClear
    nzPlaceHolder="Select the Vp volume to copy">
    @for (file of vpFiles(); track file.path) {
      <nz-option [nzValue]="file" [nzLabel]="file.name" [nzTitle]="file.path"></nz-option>
    }
    @empty {
      <nz-option nzDisabled nzValue="" nzLabel="No Vp volumes found for this job"></nz-option>
    }
  </nz-select>

  @if (selection(); as sel) {
    <div class="jvp-path">
      <span nz-icon nzType="database" nzTheme="outline" class="jvp-path-icon"></span>
      <span class="jvp-path-text">{{ sel.path }}</span>
    </div>
  }
</div>
